module.exports = __webpack_public_path__ + "img/m-hd.d7c8def6.webp";